module.exports = __webpack_public_path__ + "img/IMG_6977.fe2aaf2e.webp";